import { render, staticRenderFns } from "./OrderPageButtons.vue?vue&type=template&id=aaae41ce&scoped=true"
import script from "./OrderPageButtons.vue?vue&type=script&lang=js"
export * from "./OrderPageButtons.vue?vue&type=script&lang=js"
import style0 from "./OrderPageButtons.vue?vue&type=style&index=0&id=aaae41ce&prod&lang=less&scoped=true"
import style1 from "./OrderPageButtons.vue?vue&type=style&index=1&id=aaae41ce&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@2.0.1_webpack@4.47.0__css-loader@0.28.11_lodash@4.17.23_vue-t_lre32xywqxiddeo252btsfuiei/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaae41ce",
  null
  
)

export default component.exports